import Swiper from 'swiper/bundle';

const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;

function markFullyVisible(sw) {
  const wrapRect = sw.el.getBoundingClientRect();
  sw.slides.forEach((slide) => {
    const r = slide.getBoundingClientRect();
    const fully = r.left >= wrapRect.left + 1 && r.right <= wrapRect.right - 1;
    slide.classList.toggle('swiper-slide-fully-visible', fully);
  });
}

function dimEdgeSlides(sw) {
  sw.slides.forEach((s) => s.classList.remove('is-dimmed'));
  if (!isDesktop()) return;
  markFullyVisible(sw);
  sw.slides.forEach((s) => {
    if (
      s.classList.contains('swiper-slide-visible') &&
      !s.classList.contains('swiper-slide-fully-visible')
    ) {
      s.classList.add('is-dimmed');
    }
  });
}

function mountOne(root) {
  const el = root.querySelector('.js-products-swiper');
  if (!el) return;

  if (el._swiper && typeof el._swiper.destroy === 'function') {
    el._swiper.destroy(true, true);
    el._swiper = null;
  }

  const next = root.querySelector('.pcar-next');
  const prev = root.querySelector('.pcar-prev');
  const pagination = root.querySelector('.pcar-pagination');
  const desktopCards = Number(root.dataset.desktopCards || 4);

  const realCount = el.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
  const enableLoop = realCount > 1;

  if (next) next.style.display = realCount > 1 ? '' : 'none';
  if (prev) prev.style.display = realCount > 1 ? '' : 'none';

  const sw = new Swiper(el, {
    loop: enableLoop,
    loopAdditionalSlides: 2,
    speed: 500,
    spaceBetween: 16,
    slidesPerView: 1.15,
    centeredSlides: false,
    watchSlidesProgress: true,
    allowTouchMove: realCount > 1,
    pagination: pagination ? { el: pagination, clickable: true } : undefined,
    navigation: next && prev ? { nextEl: next, prevEl: prev } : undefined,
    breakpoints: {
      768: { slidesPerView: 2.15, spaceBetween: 16 },
      992: { slidesPerView: desktopCards, spaceBetween: 24 }
    },
    on: {
      afterInit(sw) {
        const refresh = () => {
          sw.updateSlides();
          sw.updateSlidesProgress();
          dimEdgeSlides(sw);
        };
        refresh();
        sw.on('resize', refresh);
        sw.on('breakpoint', refresh);
        sw.on('slidesLengthChange', refresh);
        sw.on('slideChange', refresh);
        sw.on('progress', refresh);
        sw.on('setTranslate', refresh);
        sw.on('transitionEnd', refresh);
      }
    }
  });

  el._swiper = sw;
}

export function initCollectionSwipers(scope = document) {
  scope.querySelectorAll('[data-products-root]').forEach((root) => mountOne(root));
}

export const initProductsSwipers = initCollectionSwipers;
